<template>
  <dl class="like">
    <dt class="like-header">
      <h4 class="like-header__left">小伙伴们还喜欢</h4>
      <div class="like-header__right">
        <!-- <router-link class="like-link__more" to="/">我要出现在这里</router-link> -->
      </div>
    </dt>
    <dd class="like-list">
      <router-link
        class="like-item"
        :to="`/detail/${item.property.topics[0].englishName}/${item.id}`"
        v-for="(item, i) in post.list"
        :key="i"
      >
        <YorkbbsImage class="like-cover" animation :src="item.property.coverImage | webpFormat(300)"></YorkbbsImage>
        <div class="like-title e-2">{{ showTitle(item) }}</div>
        <div class="like-topic">{{ item.property.topics[0].name }}</div>
      </router-link>
    </dd>
  </dl>
</template>
<script>
import {infoTitleJoint} from '@/utils/utils'
export default {
  name: 'OurLike',
  props:['postInfo'],
  data() {
    return {
      post: {
        loading: false,
        list: [],
      },
    };
  },
  created() {
    this.getPostList();
  },
  methods: {
    // 获取推荐列表
    async getPostList() {
      this.post.loading = true;
      const { code, msg, data } = await this.$axios.post('/info/v1/get/recommend/list', {
        postId: this.postInfo.id,
        offset: 1,
        size: 4,
      });
      this.post.loading = false;
      if (code != 0) return this.$error(msg);

      this.post.list = data.items;
    },
    showTitle(itemData){
      return infoTitleJoint(itemData.property.shopCnName||'',itemData.property.shopEnName||'',itemData.title||'')
    }
  },
};
</script>
<style lang="scss" scoped>
.like {
  margin-top: 50px;
}
.like-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.like-header__left {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}
.like-link__more {
  font-size: 14px;
  color: var(--primary-color);
  text-decoration: underline;
}

.like-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}

.like-item {
  box-sizing: border-box;
  padding: 10px;
  width: 260px;
  border-radius: 4px;
  &:not(:nth-child(4n)) {
    margin-right: 43.333333333333336px;
  }
  &:hover {
    box-shadow: 0 15px 20px rgba($color: #000000, $alpha: 0.1);
  }
}
.like-cover {
  width: 100%;
  height: 183px;
  border-radius: 4px;
  border: 1px solid #eee;
}
.like-title {
  font-size: 16px;
  line-height: 22px;
  color: var(--text-color-3);
  margin-top: 10px;
  &:hover {
    color: var(--primary-color);
  }
}
.like-topic {
  font-size: 14px;
  line-height: 20px;
  margin-top: 5px;
  color: var(--text-color-9);
}
</style>
